// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path d=\"M4 8.5 L7 5.5 L10 8.5\" fill=\"none\" stroke=\"%2364748b\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path d=\"M4 5.5 L7 8.5 L10 5.5\" fill=\"none\" stroke=\"%2364748b\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section "Statistiques et estimation financiere des besoins" (onglet acheteur). */
.estimation-besoins-block {
  margin: 0 0 2rem 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

/* Infobulle du nom de lot tronque : position fixe (echappe aux overflow:hidden de la
   cellule et du conteneur), affichee INSTANTANEMENT au survol (pas de delai natif). */
.estimation-besoins-tip {
  position: fixed;
  z-index: 4000;
  pointer-events: none;
  max-width: 40rem;
  padding: 0.5rem 0.8rem;
  background: #1f2937;
  color: #fff;
  font-size: 1.2rem;
  line-height: 1.4;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  white-space: normal;
}

.estimation-besoins-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background-color: #595959;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
}

.estimation-besoins-toolbar {
  display: inline-flex;
  gap: 0.25rem;
  flex-shrink: 0;
}

.estimation-besoins-asterisk {
  color: #ef4444;
  margin-left: 0.15rem;
}

.estimation-besoins-content {
  padding: 1.5rem;
  background: #fff;
}

/* Conteneur du tableau : overflow HIDDEN -> ni molette, ni trackpad, ni scrollbar.
   La navigation des annees passe EXCLUSIVEMENT par les deux fleches (scroll
   programmatique, qui fonctionne malgre overflow:hidden). Le scroll vertical de la
   page reste possible (l'evenement molette n'est pas capte). Bordure arrondie 8px. */
.estimation-besoins-table-wrap {
  /* Horizontal : clip + scroll programmatique (fleches uniquement). Vertical : scroll
     interne borne (max-height) -> le thead sticky reste visible ; les fleches, posees
     AU-DESSUS du conteneur, restent accessibles meme tout en bas du tableau. */
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 60vh;
  /* Pas de scroll-behavior: smooth ici (il clampait le centrage programmatique pose
     avant stabilisation du layout). Le smooth passe par scrollTo/scrollBy explicites. */
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

/* Scrollbar verticale complete (track + pouce + boutons haut/bas), collee au bord droit.
   Horizontale masquee : le defilement des annees passe par les fleches. */
.estimation-besoins-table-wrap::-webkit-scrollbar {
  width: 14px;
  height: 0;
}
.estimation-besoins-table-wrap::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.estimation-besoins-table-wrap::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 7px;
  border: 3px solid #f1f5f9;
}
.estimation-besoins-table-wrap::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}
/* Bouton HAUT (chevron vers le haut) a l'extremite superieure. */
.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:decrement {
  height: 14px;
  background: #f1f5f9 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
}
/* Bouton BAS (chevron vers le bas) a l'extremite inferieure. */
.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:increment {
  height: 14px;
  background: #f1f5f9 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
}
.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:decrement:hover,
.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:increment:hover {
  background-color: #e2e8f0;
}

/* Barre du carrousel des annees : libelle + deux fleches, alignees a droite. */
/* Zone relative : la barre de fleches flotte en overlay au-dessus du tableau. */
.estimation-besoins-table-zone {
  position: relative;
}

/* Fleches flottantes superposees a la 1ere et la derniere colonne d'annee visible.
   left / right / height / padding sont poses en inline (mesures JS : zone des annees, hauteur entete). */
.estimation-besoins-carousel-bar {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  z-index: 20; /* au-dessus de l'entete sticky (z-index 6/7) sinon les fleches passent derriere */
  pointer-events: none; /* laisse le tableau interactif ; seules les fleches captent le clic */
}

.estimation-besoins-carousel-label {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.estimation-besoins-arrow {
  pointer-events: auto; /* re-active le clic sur les fleches (la barre est en pointer-events:none) */
  width: 3rem;
  height: 3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background: #fff;
  color: #374151;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  transition: background 0.15s, border-color 0.15s, color 0.15s, opacity 0.15s;
}

.estimation-besoins-arrow:hover:not(:disabled) {
  background: #fff7ed;
  border-color: #f97316;
  color: #f97316;
}

.estimation-besoins-arrow:disabled {
  opacity: 0.35; /* grisee (mais visible) quand on ne peut pas scroller dans ce sens */
  cursor: default;
  pointer-events: none;
}

.estimation-besoins-table {
  /* table-layout: fixed -> chaque colonne fait EXACTEMENT la largeur de son <col>, quel
     que soit son contenu. Les colonnes d'annees sont donc toutes EGALES (un gros montant
     ne les elargit plus) : indispensable pour que n-2..n+2 tombent pile dans la zone
     visible. Largeurs (N°, Lot, annee) mesurees/calculees puis posees en JS, ainsi que la
     largeur totale (somme des colonnes -> le tableau deborde et defile, carrousel).
     recompute() bascule brievement en 'auto' pour MESURER la largeur naturelle de N° et
     Lot, puis repasse en 'fixed'. */
  table-layout: fixed;
  /* separate (pas collapse) : indispensable pour que les colonnes figees (sticky)
     masquent correctement les colonnes d'annees qui defilent dessous. */
  border-collapse: separate;
  border-spacing: 0;
  font-size: 1.3rem;
  color: #374151;
}

/* Largeurs portees par le colgroup (posees en JS). Fallback 'auto' -> pendant la passe
   de mesure (layout 'auto', variables retirees) N° et Lot prennent leur largeur naturelle ;
   en layout 'fixed', chaque colonne vaut EXACTEMENT sa variable. */
.estimation-besoins-table col.cg-lot {
  width: var(--lot-w, auto);
}
.estimation-besoins-table col.cg-libelle {
  width: var(--libelle-w, auto);
}
.estimation-besoins-table col.cg-annee {
  width: var(--year-col-w, auto);
}

/* Colonnes d'annees : contenu borne a la largeur de colonne (un gros montant ne
   l'elargit pas, garanti par table-layout: fixed). */
.estimation-besoins-table th.col-annee,
.estimation-besoins-table td.col-annee {
  overflow: hidden;
  text-overflow: ellipsis;
}

.estimation-besoins-table th,
.estimation-besoins-table td {
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  /* Separateur de colonne en border-LEFT (pas right) : ainsi aucune cellule n'a de
     bordure sur le bord droit du tableau -> pas de double avec la bordure du conteneur. */
  border-left: 1px solid #e5e7eb;
  text-align: right;
  white-space: nowrap;
}

/* Pas de bordure gauche sur la 1re colonne (bord du tableau, evite le double a gauche). */
.estimation-besoins-table th:first-child,
.estimation-besoins-table td:first-child {
  border-left: none;
}

/* Pas de bordure basse sur la derniere ligne : evite le double trait avec la
   bordure arrondie du conteneur. */
.estimation-besoins-table tfoot tr:last-child td {
  border-bottom: none;
}

/* Colonnes texte a gauche. */
.estimation-besoins-table th.col-lot,
.estimation-besoins-table td.col-lot,
.estimation-besoins-table th.col-libelle,
.estimation-besoins-table td.col-libelle {
  text-align: left;
}

.estimation-besoins-table thead th {
  font-weight: 700;
  color: #595959;
  /* 1px comme les autres lignes (le 2px lisait comme une double bordure). */
  border-bottom: 1px solid #e5e7eb;
  /* Fige verticalement : reste visible au scroll interne. Fond opaque pour que le corps
     defile dessous. z-index 6 > corps fige horizontalement (5). */
  position: sticky;
  top: 0;
  z-index: 6;
  background: #fff;
}

/* Coins haut-gauche (N° + Lot) : figes en haut ET a gauche -> au-dessus de tout. */
.estimation-besoins-table thead th.col-lot,
.estimation-besoins-table thead th.col-libelle {
  z-index: 7;
}

/* En-tetes des colonnes d'annees centres. */
.estimation-besoins-table thead th.col-annee {
  text-align: center;
}

/* Colonnes N° + Lot figees (sticky) pendant le scroll horizontal des annees. */
/* N° : largeur adaptee a son contenu. */
.col-lot {
  /* Largeur portee par <col class="cg-lot"> (layout fixe). */
  white-space: nowrap;
  position: sticky;
  left: 0;
  z-index: 5;
  background: #fff;
}

/* Libelle : largeur adaptee au contenu, figee a la suite de la colonne Lot (largeur mesuree). */
.col-libelle {
  /* Largeur portee par <col class="cg-libelle"> (bornee a 24rem en JS). Figee a la
     suite de la colonne N° (--lot-w). La troncature est portee par le span interne. */
  overflow: hidden;
  position: sticky;
  left: var(--lot-w, 6rem);
  z-index: 5;
  background: #fff;
}

/* Nom de lot : tronque a l'ellipsis sur une largeur contrainte (le span, display:block,
   remplit la cellule -> scrollWidth fiable pour detecter la troncature au survol). */
.col-libelle-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* La largeur des colonnes d'annees est portee par le colgroup (--year-col-w). */

/* Cellule de libelle de pied (Total financier, etc.) : figee a gauche (couvre Lot + Libelle). */
.foot-label {
  position: sticky;
  left: 0;
  z-index: 5;
  background: #f3f4f6;
}

/* Fleches de navigation des annees (dans le bandeau gris). */
.estimation-besoins-nav {
  background: none;
  border: none;
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  padding: 0 0.4rem;
  cursor: pointer;
}

.estimation-besoins-nav:hover {
  color: #f97316;
}

/* Annees passees : lecture seule, grisees. */
.is-past {
  color: #9ca3af;
  background: #fafafa;
}

/* "(previsionnel)" sous l'annee (en cours + futures), centre et grise. */
.estimation-besoins-previsionnel {
  display: block;
  font-weight: 400;
  font-size: 1.1rem;
  color: #9ca3af;
}

/* Banniere d'info en tete de section : 1.5rem d'espace sous elle, colle en haut du contenu. */
.estimation-besoins-notice {
  margin: 0 0 1.5rem 0;
}

/* Cellule editable : input nombre avec le symbole € A L'INTERIEUR (a droite). */
.estimation-besoins-input-wrap {
  position: relative;
  display: block;
}

.estimation-besoins-euro {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.3rem;
  color: #374151;
  pointer-events: none;
}

.estimation-besoins-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.3rem 0.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 1.3rem;
  text-align: right;
  color: #374151;
}

.estimation-besoins-input-wrap .estimation-besoins-input {
  width: 100%;
  /* Place pour le € a l'interieur, a droite, sans chevaucher le texte saisi. */
  padding-right: 1.7rem;
}

.estimation-besoins-input:focus {
  outline: none;
  border-color: #f97316;
}

/* Cellule affichant l'estimation par defaut (non encore saisie) : texte grise. */
.estimation-besoins-input.is-estimation {
  color: #9ca3af;
}

/* Flash vert bref sur une cellule qui vient d'etre sauvegardee. */
.estimation-besoins-input.is-saved {
  animation: estim-saved-flash 1.4s ease;
}

@keyframes estim-saved-flash {
  0% {
    background: #dcfce7;
    border-color: #16a34a;
  }
  100% {
    background: #fff;
    border-color: #e5e7eb;
  }
}

/* Indicateur d'etat de sauvegarde dans le bandeau gris. */
.estimation-besoins-savestatus {
  font-size: 1.2rem;
  font-weight: 500;
  color: #e5e7eb;
  white-space: nowrap;
}

.estimation-besoins-savestatus.is-saved {
  color: #86efac;
}

.estimation-besoins-readonly {
  display: block;
  text-align: right;
}

.estimation-besoins-loading {
  text-align: center;
  color: #6b7280;
  padding: 1.5rem;
}

/* Skeleton du tableau (chargement + montage) : barres grises pulsantes, meme
   structure que le tableau reel -> pas de "saut" a l'apparition des donnees. */
.estim-skel-bar {
  /* Cellule annee : meme gabarit qu'un input (pleine largeur, hauteur input) pour
     que la ligne skeleton ait EXACTEMENT la meme hauteur que la ligne reelle. */
  display: block;
  width: 100%;
  height: 2.2rem;
  box-sizing: border-box;
  border-radius: 4px;
  background: #eef0f2;
  animation: estim-skel-pulse 1.2s ease-in-out infinite;
}
.estim-skel-bar--code {
  display: inline-block;
  width: 2.6rem;
  height: 1.4rem;
}
.estim-skel-bar--lot {
  /* Largeur proche d'un nom de lot reel -> la colonne Lot technique ne bouge pas
     a l'apparition des donnees. */
  display: inline-block;
  width: 18rem;
  max-width: 100%;
  height: 1.4rem;
}
@keyframes estim-skel-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Ligne Nouveau / Autres. */
/* Bouton "Suggerer un lot" : bouton secondary standard, juste un padding reduit pour
   ne pas avoir trop d'espace lateral. */
.estimation-besoins-table .estimation-besoins-nouveau-row .estimation-besoins-suggest-btn {
  padding: 8px 18px;
}

.estimation-besoins-nouveau-row td {
  background: #f9fafb;
  /* Aucune bordure verticale sur la ligne Proposition (on garde la bordure basse). */
  border-left: none;
}

.estimation-besoins-nouveau-btn {
  background: none;
  border: 1px dashed #f97316;
  color: #f97316;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0.4rem 1rem;
  border-radius: 6px;
  cursor: pointer;
}

.estimation-besoins-nouveau-btn:hover {
  background: #fff7ed;
}

/* Pied de tableau. */
.estimation-besoins-table tfoot td {
  background: #f3f4f6;
  font-weight: 600;
}

.estimation-besoins-total td {
  font-weight: 700;
  color: #374151;
  /* Pas de border-top : la bordure basse de la derniere ligne de corps separe deja
     le corps du pied (sinon double trait). */
}

.estimation-besoins-foot-detail td:first-child {
  padding-left: 2rem;
  font-weight: 500;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/composants/EstimationBesoins/EstimationBesoins.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;sFACsF;AACtF;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;qFAGqF;AACrF;EACE;;+EAE6E;EAC7E,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB;wFACsF;EACtF,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;0EAC0E;AAC1E;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA,iEAAiE;AACjE;EACE,YAAY;EACZ,4EAA+R;AACjS;AACA,+DAA+D;AAC/D;EACE,YAAY;EACZ,4EAA+R;AACjS;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E,gFAAgF;AAChF;EACE,kBAAkB;AACpB;;AAEA;yGACyG;AACzG;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW,EAAE,kFAAkF;EAC/F,oBAAoB,EAAE,sEAAsE;AAC9F;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB,EAAE,4EAA4E;EAClG,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,qEAAqE;EACpF,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;;;;;;oCAMkC;EAClC,mBAAmB;EACnB;wEACsE;EACtE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;mEAEmE;AACnE;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;;AAEA;qDACqD;AACrD;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;EAChC;0FACwF;EACxF,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0FAA0F;AAC1F;;EAEE,iBAAiB;AACnB;;AAEA;mCACmC;AACnC;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0EAA0E;EAC1E,gCAAgC;EAChC;kEACgE;EAChE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;;EAEE,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E,wCAAwC;AACxC;EACE,2DAA2D;EAC3D,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA,gGAAgG;AAChG;EACE;sFACoF;EACpF,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;AAClB;;AAEA;qFACqF;AACrF;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gFAAgF;;AAEhF,gGAAgG;AAChG;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8FAA8F;AAC9F;EACE,oBAAoB;AACtB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6EAA6E;EAC7E,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iFAAiF;AACjF;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;+EAC+E;AAC/E;EACE;gFAC8E;EAC9E,cAAc;EACd,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;AACA;EACE;kCACgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,4BAA4B;AAC5B;wCACwC;AACxC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mFAAmF;EACnF,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;6CAC2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* Section \"Statistiques et estimation financiere des besoins\" (onglet acheteur). */\n.estimation-besoins-block {\n  margin: 0 0 2rem 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Infobulle du nom de lot tronque : position fixe (echappe aux overflow:hidden de la\n   cellule et du conteneur), affichee INSTANTANEMENT au survol (pas de delai natif). */\n.estimation-besoins-tip {\n  position: fixed;\n  z-index: 4000;\n  pointer-events: none;\n  max-width: 40rem;\n  padding: 0.5rem 0.8rem;\n  background: #1f2937;\n  color: #fff;\n  font-size: 1.2rem;\n  line-height: 1.4;\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  white-space: normal;\n}\n\n.estimation-besoins-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background-color: #595959;\n  color: #fff;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.estimation-besoins-toolbar {\n  display: inline-flex;\n  gap: 0.25rem;\n  flex-shrink: 0;\n}\n\n.estimation-besoins-asterisk {\n  color: #ef4444;\n  margin-left: 0.15rem;\n}\n\n.estimation-besoins-content {\n  padding: 1.5rem;\n  background: #fff;\n}\n\n/* Conteneur du tableau : overflow HIDDEN -> ni molette, ni trackpad, ni scrollbar.\n   La navigation des annees passe EXCLUSIVEMENT par les deux fleches (scroll\n   programmatique, qui fonctionne malgre overflow:hidden). Le scroll vertical de la\n   page reste possible (l'evenement molette n'est pas capte). Bordure arrondie 8px. */\n.estimation-besoins-table-wrap {\n  /* Horizontal : clip + scroll programmatique (fleches uniquement). Vertical : scroll\n     interne borne (max-height) -> le thead sticky reste visible ; les fleches, posees\n     AU-DESSUS du conteneur, restent accessibles meme tout en bas du tableau. */\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 60vh;\n  /* Pas de scroll-behavior: smooth ici (il clampait le centrage programmatique pose\n     avant stabilisation du layout). Le smooth passe par scrollTo/scrollBy explicites. */\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n/* Scrollbar verticale complete (track + pouce + boutons haut/bas), collee au bord droit.\n   Horizontale masquee : le defilement des annees passe par les fleches. */\n.estimation-besoins-table-wrap::-webkit-scrollbar {\n  width: 14px;\n  height: 0;\n}\n.estimation-besoins-table-wrap::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n.estimation-besoins-table-wrap::-webkit-scrollbar-thumb {\n  background: #94a3b8;\n  border-radius: 7px;\n  border: 3px solid #f1f5f9;\n}\n.estimation-besoins-table-wrap::-webkit-scrollbar-thumb:hover {\n  background: #64748b;\n}\n/* Bouton HAUT (chevron vers le haut) a l'extremite superieure. */\n.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:decrement {\n  height: 14px;\n  background: #f1f5f9 url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path d=\"M4 8.5 L7 5.5 L10 8.5\" fill=\"none\" stroke=\"%2364748b\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>') center no-repeat;\n}\n/* Bouton BAS (chevron vers le bas) a l'extremite inferieure. */\n.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:increment {\n  height: 14px;\n  background: #f1f5f9 url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path d=\"M4 5.5 L7 8.5 L10 5.5\" fill=\"none\" stroke=\"%2364748b\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>') center no-repeat;\n}\n.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:decrement:hover,\n.estimation-besoins-table-wrap::-webkit-scrollbar-button:single-button:vertical:increment:hover {\n  background-color: #e2e8f0;\n}\n\n/* Barre du carrousel des annees : libelle + deux fleches, alignees a droite. */\n/* Zone relative : la barre de fleches flotte en overlay au-dessus du tableau. */\n.estimation-besoins-table-zone {\n  position: relative;\n}\n\n/* Fleches flottantes superposees a la 1ere et la derniere colonne d'annee visible.\n   left / right / height / padding sont poses en inline (mesures JS : zone des annees, hauteur entete). */\n.estimation-besoins-carousel-bar {\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  z-index: 20; /* au-dessus de l'entete sticky (z-index 6/7) sinon les fleches passent derriere */\n  pointer-events: none; /* laisse le tableau interactif ; seules les fleches captent le clic */\n}\n\n.estimation-besoins-carousel-label {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.estimation-besoins-arrow {\n  pointer-events: auto; /* re-active le clic sur les fleches (la barre est en pointer-events:none) */\n  width: 3rem;\n  height: 3rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d1d5db;\n  border-radius: 50%;\n  background: #fff;\n  color: #374151;\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  transition: background 0.15s, border-color 0.15s, color 0.15s, opacity 0.15s;\n}\n\n.estimation-besoins-arrow:hover:not(:disabled) {\n  background: #fff7ed;\n  border-color: #f97316;\n  color: #f97316;\n}\n\n.estimation-besoins-arrow:disabled {\n  opacity: 0.35; /* grisee (mais visible) quand on ne peut pas scroller dans ce sens */\n  cursor: default;\n  pointer-events: none;\n}\n\n.estimation-besoins-table {\n  /* table-layout: fixed -> chaque colonne fait EXACTEMENT la largeur de son <col>, quel\n     que soit son contenu. Les colonnes d'annees sont donc toutes EGALES (un gros montant\n     ne les elargit plus) : indispensable pour que n-2..n+2 tombent pile dans la zone\n     visible. Largeurs (N°, Lot, annee) mesurees/calculees puis posees en JS, ainsi que la\n     largeur totale (somme des colonnes -> le tableau deborde et defile, carrousel).\n     recompute() bascule brievement en 'auto' pour MESURER la largeur naturelle de N° et\n     Lot, puis repasse en 'fixed'. */\n  table-layout: fixed;\n  /* separate (pas collapse) : indispensable pour que les colonnes figees (sticky)\n     masquent correctement les colonnes d'annees qui defilent dessous. */\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n/* Largeurs portees par le colgroup (posees en JS). Fallback 'auto' -> pendant la passe\n   de mesure (layout 'auto', variables retirees) N° et Lot prennent leur largeur naturelle ;\n   en layout 'fixed', chaque colonne vaut EXACTEMENT sa variable. */\n.estimation-besoins-table col.cg-lot {\n  width: var(--lot-w, auto);\n}\n.estimation-besoins-table col.cg-libelle {\n  width: var(--libelle-w, auto);\n}\n.estimation-besoins-table col.cg-annee {\n  width: var(--year-col-w, auto);\n}\n\n/* Colonnes d'annees : contenu borne a la largeur de colonne (un gros montant ne\n   l'elargit pas, garanti par table-layout: fixed). */\n.estimation-besoins-table th.col-annee,\n.estimation-besoins-table td.col-annee {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.estimation-besoins-table th,\n.estimation-besoins-table td {\n  padding: 0.6rem 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n  /* Separateur de colonne en border-LEFT (pas right) : ainsi aucune cellule n'a de\n     bordure sur le bord droit du tableau -> pas de double avec la bordure du conteneur. */\n  border-left: 1px solid #e5e7eb;\n  text-align: right;\n  white-space: nowrap;\n}\n\n/* Pas de bordure gauche sur la 1re colonne (bord du tableau, evite le double a gauche). */\n.estimation-besoins-table th:first-child,\n.estimation-besoins-table td:first-child {\n  border-left: none;\n}\n\n/* Pas de bordure basse sur la derniere ligne : evite le double trait avec la\n   bordure arrondie du conteneur. */\n.estimation-besoins-table tfoot tr:last-child td {\n  border-bottom: none;\n}\n\n/* Colonnes texte a gauche. */\n.estimation-besoins-table th.col-lot,\n.estimation-besoins-table td.col-lot,\n.estimation-besoins-table th.col-libelle,\n.estimation-besoins-table td.col-libelle {\n  text-align: left;\n}\n\n.estimation-besoins-table thead th {\n  font-weight: 700;\n  color: #595959;\n  /* 1px comme les autres lignes (le 2px lisait comme une double bordure). */\n  border-bottom: 1px solid #e5e7eb;\n  /* Fige verticalement : reste visible au scroll interne. Fond opaque pour que le corps\n     defile dessous. z-index 6 > corps fige horizontalement (5). */\n  position: sticky;\n  top: 0;\n  z-index: 6;\n  background: #fff;\n}\n\n/* Coins haut-gauche (N° + Lot) : figes en haut ET a gauche -> au-dessus de tout. */\n.estimation-besoins-table thead th.col-lot,\n.estimation-besoins-table thead th.col-libelle {\n  z-index: 7;\n}\n\n/* En-tetes des colonnes d'annees centres. */\n.estimation-besoins-table thead th.col-annee {\n  text-align: center;\n}\n\n/* Colonnes N° + Lot figees (sticky) pendant le scroll horizontal des annees. */\n/* N° : largeur adaptee a son contenu. */\n.col-lot {\n  /* Largeur portee par <col class=\"cg-lot\"> (layout fixe). */\n  white-space: nowrap;\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  background: #fff;\n}\n\n/* Libelle : largeur adaptee au contenu, figee a la suite de la colonne Lot (largeur mesuree). */\n.col-libelle {\n  /* Largeur portee par <col class=\"cg-libelle\"> (bornee a 24rem en JS). Figee a la\n     suite de la colonne N° (--lot-w). La troncature est portee par le span interne. */\n  overflow: hidden;\n  position: sticky;\n  left: var(--lot-w, 6rem);\n  z-index: 5;\n  background: #fff;\n}\n\n/* Nom de lot : tronque a l'ellipsis sur une largeur contrainte (le span, display:block,\n   remplit la cellule -> scrollWidth fiable pour detecter la troncature au survol). */\n.col-libelle-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* La largeur des colonnes d'annees est portee par le colgroup (--year-col-w). */\n\n/* Cellule de libelle de pied (Total financier, etc.) : figee a gauche (couvre Lot + Libelle). */\n.foot-label {\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  background: #f3f4f6;\n}\n\n/* Fleches de navigation des annees (dans le bandeau gris). */\n.estimation-besoins-nav {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 2rem;\n  line-height: 1;\n  padding: 0 0.4rem;\n  cursor: pointer;\n}\n\n.estimation-besoins-nav:hover {\n  color: #f97316;\n}\n\n/* Annees passees : lecture seule, grisees. */\n.is-past {\n  color: #9ca3af;\n  background: #fafafa;\n}\n\n/* \"(previsionnel)\" sous l'annee (en cours + futures), centre et grise. */\n.estimation-besoins-previsionnel {\n  display: block;\n  font-weight: 400;\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n/* Banniere d'info en tete de section : 1.5rem d'espace sous elle, colle en haut du contenu. */\n.estimation-besoins-notice {\n  margin: 0 0 1.5rem 0;\n}\n\n/* Cellule editable : input nombre avec le symbole € A L'INTERIEUR (a droite). */\n.estimation-besoins-input-wrap {\n  position: relative;\n  display: block;\n}\n\n.estimation-besoins-euro {\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.3rem;\n  color: #374151;\n  pointer-events: none;\n}\n\n.estimation-besoins-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.3rem 0.4rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 1.3rem;\n  text-align: right;\n  color: #374151;\n}\n\n.estimation-besoins-input-wrap .estimation-besoins-input {\n  width: 100%;\n  /* Place pour le € a l'interieur, a droite, sans chevaucher le texte saisi. */\n  padding-right: 1.7rem;\n}\n\n.estimation-besoins-input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n/* Cellule affichant l'estimation par defaut (non encore saisie) : texte grise. */\n.estimation-besoins-input.is-estimation {\n  color: #9ca3af;\n}\n\n/* Flash vert bref sur une cellule qui vient d'etre sauvegardee. */\n.estimation-besoins-input.is-saved {\n  animation: estim-saved-flash 1.4s ease;\n}\n\n@keyframes estim-saved-flash {\n  0% {\n    background: #dcfce7;\n    border-color: #16a34a;\n  }\n  100% {\n    background: #fff;\n    border-color: #e5e7eb;\n  }\n}\n\n/* Indicateur d'etat de sauvegarde dans le bandeau gris. */\n.estimation-besoins-savestatus {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #e5e7eb;\n  white-space: nowrap;\n}\n\n.estimation-besoins-savestatus.is-saved {\n  color: #86efac;\n}\n\n.estimation-besoins-readonly {\n  display: block;\n  text-align: right;\n}\n\n.estimation-besoins-loading {\n  text-align: center;\n  color: #6b7280;\n  padding: 1.5rem;\n}\n\n/* Skeleton du tableau (chargement + montage) : barres grises pulsantes, meme\n   structure que le tableau reel -> pas de \"saut\" a l'apparition des donnees. */\n.estim-skel-bar {\n  /* Cellule annee : meme gabarit qu'un input (pleine largeur, hauteur input) pour\n     que la ligne skeleton ait EXACTEMENT la meme hauteur que la ligne reelle. */\n  display: block;\n  width: 100%;\n  height: 2.2rem;\n  box-sizing: border-box;\n  border-radius: 4px;\n  background: #eef0f2;\n  animation: estim-skel-pulse 1.2s ease-in-out infinite;\n}\n.estim-skel-bar--code {\n  display: inline-block;\n  width: 2.6rem;\n  height: 1.4rem;\n}\n.estim-skel-bar--lot {\n  /* Largeur proche d'un nom de lot reel -> la colonne Lot technique ne bouge pas\n     a l'apparition des donnees. */\n  display: inline-block;\n  width: 18rem;\n  max-width: 100%;\n  height: 1.4rem;\n}\n@keyframes estim-skel-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n/* Ligne Nouveau / Autres. */\n/* Bouton \"Suggerer un lot\" : bouton secondary standard, juste un padding reduit pour\n   ne pas avoir trop d'espace lateral. */\n.estimation-besoins-table .estimation-besoins-nouveau-row .estimation-besoins-suggest-btn {\n  padding: 8px 18px;\n}\n\n.estimation-besoins-nouveau-row td {\n  background: #f9fafb;\n  /* Aucune bordure verticale sur la ligne Proposition (on garde la bordure basse). */\n  border-left: none;\n}\n\n.estimation-besoins-nouveau-btn {\n  background: none;\n  border: 1px dashed #f97316;\n  color: #f97316;\n  font-weight: 600;\n  font-size: 1.3rem;\n  padding: 0.4rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.estimation-besoins-nouveau-btn:hover {\n  background: #fff7ed;\n}\n\n/* Pied de tableau. */\n.estimation-besoins-table tfoot td {\n  background: #f3f4f6;\n  font-weight: 600;\n}\n\n.estimation-besoins-total td {\n  font-weight: 700;\n  color: #374151;\n  /* Pas de border-top : la bordure basse de la derniere ligne de corps separe deja\n     le corps du pied (sinon double trait). */\n}\n\n.estimation-besoins-foot-detail td:first-child {\n  padding-left: 2rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
